import React from 'react';
import styled from 'styled-components';
import { numberFormat } from '../../helpers/utils'
import { ThemeProps } from './globalStyles';


const CharacterCounter = ({
    maxNumberCharacters = -1,
    numberCharacters = 1,
    ...rest
}) => {

    const NumberChar = styled.label`
    color:${numberCharacters > maxNumberCharacters ? 'red' : ThemeProps.color.gabaGreen}`;
    if (isNaN(maxNumberCharacters) || maxNumberCharacters < 0)
        return null;
    else
        return (
            <div style={rest.style}>
                <NumberChar>{numberFormat(numberCharacters)}</NumberChar> / {numberFormat(maxNumberCharacters)}
            </div>
        );
}

export { CharacterCounter };

